import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';

export default reduxFetch([
  {
    resource: `principalsComplete`,
    method: 'get',
    request: filters => ({
      url: addParametersToUri(apiRoutes.principals(), filters),
      clearValueOnRequest: true,
    }),
  },
]);
